import { render } from "./HomeView.vue?vue&type=template&id=3c80206d&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=3c80206d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\victoria.matthews\\Documents\\yield-client\\yield-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c80206d"]])

export default __exports__